module.exports = __webpack_public_path__ + "static/media/72.eff5143a.jpg";